import {React ,useEffect,useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserDetailsForm from "../Component/UserDetailsForm";
import HeroBanner from "../Sections/HeroBanner";
import RequestExtras from "../Component/RequestExtras";
import Payment from "../Component/Payment";
import CouponCodeInput from "../Component/CouponCodeInput";
import { useTransferSearch } from "../Component/TransferSearchContext";
import { HiMinusSm, HiPlusSm } from "react-icons/hi";

const TransferBooking = () => {
  const [extras, setExtras] = useState({});
  const handleExtrasChange = (newExtras) => {
    setExtras(newExtras);
    //console.log("Updated extras:", newExtras);
  };
  const { searchData } = useTransferSearch();
  const confirmTransferNavigate = useNavigate();
  const location = useLocation();
  const transferData = location.state?.transferData;
  const responcetype = location.state?.responcetype;
  //console.log(transferData);
  //console.log(searchData);
  //console.log(responcetype);

  const [passengerQnt, setPassengerQnt] = useState(() => {
    return searchData?.passengers > 0 ? searchData.passengers : 1;
  });
  const maxPax = transferData?.max_pax; // fallback to 5 if undefined
  
  const handlePassenger = (action) => {
    setPassengerQnt(prev => {
      if (action === "increment" && prev < maxPax) return prev + 1;
      if (action === "decrement" && prev > 1) return prev - 1;
      return prev;
    });
  };

  const getvehicledetails = async () =>  {
    const payload = {
      vehicle_id: transferData.vehicle_id,
    };
  
    try {
      const res = await fetch("https://login.flymiles.com.au/api_sections/transafer/front_end/get_single_vehicle_detail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const result = await res.json();
      //console.log(result);
     
      
    } catch (err) {
      console.error("Search failed", err);
    }

  };
  useEffect(() => {
    getvehicledetails();
  }, []); 
  const handleConfirmBooking = (e, transferBookingData) => {
    confirmTransferNavigate(`/transfer-booking-confirm`, {state: {transferBookingData}})
  };

  const fullPayAmount =
    Number(transferData.price || 0) +
    Number(extras.totalLuggagePrice || 0) +
    Number(extras.totalSurfboardPrice || 0) +
    Number(extras.totalBabySeatsPrice || 0) +
    Number(extras.totalBabyBoosterPrice || 0);

  const payAmount =
    responcetype === "pay_later" ? Math.round(0.2 * fullPayAmount) : fullPayAmount;


  return (
    <>
      <div className="">
        <HeroBanner
          text={"Transfer"}
          imgUrl={"/assets/contact/hero-banner.png"}
        />
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 mx-3 py-12">
          <div className="lg:w-[calc(70%-12px)]">
            <UserDetailsForm vehicle_id={transferData.vehicle_id} responcetype={responcetype} singleprice={transferData.price} updatedpes={passengerQnt} extras={extras}/>
            <RequestExtras  onExtrasChange={(data) => setExtras(data)}/>
            {responcetype === "book_noww" && (
            <Payment onClick={(e) => handleConfirmBooking(e, transferData)} total={payAmount} />
            )}
          </div>
          <div className="lg:w-[calc(30%-12px)]">
            <div className="p-3 border rounded">
              <div className="border rounded h-[200px] flex items-center justify-center">
                <img
                  className="h-[150px] flex-none object-contain"
                  src={transferData.vehicle_img}
                  alt=""
                />
              </div>
              <h1 className="font-semibold text-center mt-3 text-xl">
                {transferData.vehicle_type_name}({transferData.make})
              </h1>
              {/* <CouponCodeInput /> */}
              <div className="mt-6 border-t pt-6">
                <p className="text-xl font-medium mb-3">Vehicle Details</p>
                {/* <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Route</p>
                  <p>{transferData.route}</p>
                </div> */}
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Vehicle Type</p>
                  <p>{transferData.make}{transferData.model}</p>
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Max Passengers</p>
                  <p>{transferData.max_pax}</p>
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Max lugguage</p>
                  <p>{transferData.max_lugg}</p>
                </div>
                <div className="flex justify-between gap-3">
                  <p className="font-semibold">Description</p>
                  <p>{transferData.vehicle_type_des}</p>
                </div>
              </div>
              <div className="mt-6 border-t pt-6">
                <p className="text-xl font-medium mb-3">Search Details</p>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">From</p>
                  <p className="text-seconday" style={{wordBreak: "break-all",whiteSpace:"normal",  textAlign: "end"}}>{searchData.from?.label || "—"}</p> {/* Accessing 'value' if it's an object */}
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">To</p>
                  <p className="text-seconday" style={{wordBreak: "break-all",whiteSpace:"normal", textAlign: "end"}}>{searchData.to?.label || "—"}</p> {/* Same for 'to' */}
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Date</p>
                  <p className="text-seconday">
                    {new Date(searchData.date).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </p>
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Time</p>
                  <p className="text-seconday">
                  {String(searchData.time.hour).padStart(2, '0')}:{String(searchData.time.minute).padStart(2, '0')}
                    
                  </p>
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Passengers</p>
                  <p className="text-seconday">{passengerQnt}</p>
                </div>
              </div>
              {responcetype !== "get_qoute" && (
              <div className="mt-6 border-t pt-6">
                <p className="text-xl font-medium mb-3">Extra Requests</p>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Extra Luggage</p>
                  <p className="text-seconday" style={{wordBreak: "break-all",whiteSpace:"normal",  textAlign: "end"}}>AU$ {extras.totalLuggagePrice}</p> {/* Accessing 'value' if it's an object */}
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Surfboard</p>
                  <p className="text-seconday" style={{wordBreak: "break-all",whiteSpace:"normal", textAlign: "end"}}>AU$ {extras.totalSurfboardPrice}</p> {/* Same for 'to' */}
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Baby Seats</p>
                  <p className="text-seconday" style={{wordBreak: "break-all",whiteSpace:"normal", textAlign: "end"}}>AU$ {extras.totalBabySeatsPrice}</p> {/* Same for 'to' */}
                </div>
                <div className="flex justify-between gap-3 mb-3">
                  <p className="font-semibold">Baby Booster</p>
                  <p className="text-seconday" style={{wordBreak: "break-all",whiteSpace:"normal", textAlign: "end"}}>AU$ {extras.totalBabyBoosterPrice}</p> {/* Same for 'to' */}
                </div>
              </div>
              )}
              {responcetype !== "get_qoute" && (
                <div className="mt-6 border-t pt-6">
                  <p className="text-xl font-medium mb-3">Payment</p>
                  <div className="flex justify-between gap-3 mb-3">
                    <p className="font-semibold">Update Pessenger</p>
                    <div className="flex gap-2 items-center justify-between border rounded px-2">
                      <input
                        className="absolute right-0 top-0 sm:relative flex-none focus:outline-none w-9 h-9"
                        type="number"
                        value={passengerQnt}
                        readOnly
                      />
                      <div className="flex items-center gap-1">
                        <button
                          onClick={() => handlePassenger("decrement")}
                          className="bg-[#FFA100] h-6 w-6 flex items-center justify-center text-white text-2xl"
                        >
                          <HiMinusSm />
                        </button>
                        <button
                          onClick={() => handlePassenger("increment")}
                          className="bg-[#FFA100] h-6 w-6 flex items-center justify-center text-white text-2xl"
                        >
                          <HiPlusSm />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between gap-3 mb-3">
                    <p className="font-semibold">Pay Amount <br></br>
                    {responcetype == "pay_later" && (
                        <span style={{ fontSize: "11px", color: "red" }}>Pay 20% (AU$ {Math.round(
                          0.2 * (
                            Number(transferData.price || 0) +
                            Number(extras.totalLuggagePrice || 0) +
                            Number(extras.totalSurfboardPrice || 0) +
                            Number(extras.totalBabySeatsPrice || 0) +
                            Number(extras.totalBabyBoosterPrice || 0)
                          )
                        )}
                          ) Now to Reserve the booking<br></br>80% - 48 hours before travel.</span>
                    )}
                    </p>
                    <p className="text-secondary">
                      AU$ {Number(transferData.price || 0) +
                        Number(extras.totalLuggagePrice || 0) +
                        Number(extras.totalSurfboardPrice || 0) +
                        Number(extras.totalBabySeatsPrice || 0) +
                        Number(extras.totalBabyBoosterPrice || 0)}
                    </p>

                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransferBooking;
